/**
 * Campaign settings: every word on the page, the countdown deadline and the button link.
 * Edit the values below and the page updates. Nothing else needs to change.
 */
export const campaign = {
    // Browser tab title, and the title shown when the link is shared.
    pageTitle: 'Niagara Square Bills Rally – 10/29',

    // Description shown when the link is shared on social media or listed in search results.
    shareDescription: 'All eyes up. The countdown is on.',

    // Keep the page out of search results while it is a concept under review. Set to true at launch.
    allowSearchIndexing: false,

    // Main line above the countdown. A trailing period is drawn in the accent red.
    headline: 'SOMETHING EPIC IS COMING.',

    // The event flyer that fills the homepage, with the text screen readers announce for it.
    flyer: {
        src: '/images/event-flyer.jpg',
        width: 1080,
        height: 1350,
        alt: 'All Ages Bills Rally, Niagara Square, 10/29/26, 5:30–7:30 PM. Laser light show, beer and food trucks, DJ Milk and DJ Yes, BFLO Cheerleaders, Bills and Gatorade giveaways.'
    },

    // The exact moment the countdown ends. Keep the UTC offset at the end so every visitor,
    // in any timezone, counts down to the same instant.
    // 5:30 PM America/New_York on October 29, 2026. Daylight time is still in effect then (EDT, UTC-04:00).
    // For a New York time between early November and mid March (standard time), end with -05:00 instead.
    deadline: '2026-10-29T17:30:00-04:00',

    // Replaces the countdown once the deadline has passed.
    zeroStateMessage: 'THE WAIT IS OVER.',

    // The single call to action on the countdown page.
    button: {
        label: 'REGISTER TO ATTEND',
        href: '/register'
    },

    // Small line under the button.
    buttonDetail: 'October 29 · 5:30–8:00 PM ET',
    buttonLocation: 'Niagara Square',

    // Partner logos along the bottom of the homepage, in display order. Heights are tuned per mark
    // (Tailwind classes) so the round seal, the wide buffalo and the tall G read as the same weight.
    partners: [
        { name: 'City of Buffalo', src: '/images/partners/city-of-buffalo-seal.png', width: 1760, height: 1760, sizeClass: 'h-9 sm:h-11' },
        { name: 'Visit Buffalo', src: '/images/partners/visit-buffalo.png', width: 1500, height: 550, sizeClass: 'h-6 sm:h-8' },
        { name: 'Gatorade', src: '/images/partners/gatorade.png', width: 830, height: 860, sizeClass: 'h-9 sm:h-11' }
    ],

    // Discreet note at the bottom of the page.
    note: 'Concept preview — copy, countdown date, and link pending approval.',

    // Labels under each part of the countdown.
    units: {
        days: 'DAYS',
        hours: 'HOURS',
        minutes: 'MINUTES',
        seconds: 'SECONDS'
    },

    // Read aloud by screen readers only, never shown on screen.
    accessibility: {
        timerPrefix: 'Time remaining:',
        newTabHint: '(opens in a new tab)'
    },

    // The registration page at /register, and the confirmation email registrants receive.
    // {firstName} in the email body is replaced with the person's first name.
    register: {
        pageTitle: 'Register',
        heading: 'REGISTER TO ATTEND',
        intro: 'Enter your details below to register your interest in attending.',
        fields: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email address'
        },
        submit: 'SUBMIT REGISTRATION',
        submitting: 'SUBMITTING…',
        success: "Thanks! We’ve received your registration.",
        arrival: 'Please arrive at Niagara Square in Buffalo, NY, by 5:30 PM ET on October 29.',
        backLink: 'Back to countdown',
        errors: {
            firstNameRequired: 'Please enter your first name.',
            lastNameRequired: 'Please enter your last name.',
            nameInvalid: 'Please use letters only, up to 80 characters.',
            emailRequired: 'Please enter your email address.',
            emailInvalid: 'Please enter a valid email address.',
            duplicate: 'This email address is already registered.',
            rateLimited: 'Too many attempts. Please wait a few minutes and try again.',
            generic: 'Something went wrong and your registration was not saved. Please try again.'
        },
        confirmationEmail: {
            subject: 'Registration received',
            body: 'Thanks for registering! Please arrive at Niagara Square in Buffalo, NY, by 5:30 PM ET on October 29.',
            footer: 'This is an automated confirmation. Replies are not monitored.'
        }
    },

    // Only seen when someone opens an address that does not exist, or when something breaks.
    errorPages: {
        notFound: {
            title: 'Page not found',
            heading: 'PAGE NOT FOUND.',
            link: 'BACK TO THE COUNTDOWN'
        },
        serverError: {
            title: 'Something went wrong',
            heading: 'SOMETHING WENT WRONG.',
            link: 'BACK TO THE COUNTDOWN'
        }
    }
} as const
